/* ez-installer-locator.js — interactive installer locator (faithful port of
   demo/app/find-an-installer/page.jsx). Leaflet 1.9.4 + MarkerCluster 1.5.3 (unpkg,
   loaded on demand), CARTO light basemap, Nominatim city/ZIP geocode, browser
   geolocation. Progressive enhancement: with JS off the <noscript> directory shows;
   this script takes over the left list + right map when it runs. Data is fetched from
   the ez-installers.json theme asset (all 182 records incl. lat/lng). No dependencies. */
(function () {
  "use strict";
  var AC = "#c4622a";
  var RADII = [{ v: 25, l: "25 mi" }, { v: 50, l: "50 mi" }, { v: 100, l: "100 mi" }, { v: 250, l: "250 mi" }, { v: 0, l: "Any" }];
  var DEFAULT_RADIUS = 100;
  var POPULAR = ["Denver, CO", "Phoenix, AZ", "Dallas, TX", "Portland, OR", "Bozeman, MT"];
  var LEAFLET_CSS = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.css";
  var MC_CSS1 = "https://unpkg.com/leaflet.markercluster@1.5.3/dist/MarkerCluster.css";
  var MC_CSS2 = "https://unpkg.com/leaflet.markercluster@1.5.3/dist/MarkerCluster.Default.css";
  var LEAFLET_JS = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.js";
  var MC_JS = "https://unpkg.com/leaflet.markercluster@1.5.3/dist/leaflet.markercluster.js";

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  function loadCss(href) {
    if (!href) return;
    var links = document.querySelectorAll('link[rel="stylesheet"]');
    for (var i = 0; i < links.length; i++) { if (links[i].href === href) return; }
    var l = document.createElement("link");
    l.rel = "stylesheet"; l.href = href;
    document.head.appendChild(l);
  }
  function loadScript(src) {
    return new Promise(function (res, rej) {
      var ex = document.querySelector('script[src="' + src + '"]');
      if (ex) {
        if (ex.dataset.loaded) return res();
        ex.addEventListener("load", function () { res(); });
        ex.addEventListener("error", rej);
        return;
      }
      var s = document.createElement("script");
      s.src = src; s.async = true;
      s.onload = function () { s.dataset.loaded = "1"; res(); };
      s.onerror = rej;
      document.head.appendChild(s);
    });
  }
  var webUrl = function (w) { return /^https?:/i.test(w) ? w : "https://" + w; };
  function dirUrl(i, o) {
    var dest = i.lat != null ? i.lat + "," + i.lng : encodeURIComponent(i.name + " " + i.city + " " + i.state);
    var from = o ? "&origin=" + o.lat + "," + o.lng : "";
    return "https://www.google.com/maps/dir/?api=1&destination=" + dest + from;
  }
  function milesBetween(a, b) {
    if (a.lat == null || b.lat == null) return Infinity;
    var R = 3958.8, toR = function (d) { return (d * Math.PI) / 180; };
    var dLat = toR(b.lat - a.lat), dLng = toR(b.lng - a.lng);
    var s = Math.pow(Math.sin(dLat / 2), 2) + Math.cos(toR(a.lat)) * Math.cos(toR(b.lat)) * Math.pow(Math.sin(dLng / 2), 2);
    return 2 * R * Math.asin(Math.sqrt(s));
  }
  function geocode(q) {
    return fetch("https://nominatim.openstreetmap.org/search?format=json&limit=5&countrycodes=us,ca&q=" + encodeURIComponent(q), { headers: { "Accept-Language": "en" } })
      .then(function (r) { return r.json(); })
      .then(function (j) { return (j || []).map(function (x) { return { lat: +x.lat, lng: +x.lon, label: x.display_name }; }); });
  }
  var TEL = function (p) { return p.replace(/[^0-9]/g, ""); };

  function typeIconSvg(t, size) {
    size = size || 13;
    var open = '<svg width="' + size + '" height="' + size + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">';
    var body;
    if (t === "Mobile RV tech") body = '<path d="M1 4h13v11H1zM14 7h4l3 3v5h-7"/><circle cx="6" cy="18" r="2"/><circle cx="17" cy="18" r="2"/>';
    else if (t === "RV dealer") body = '<path d="M3 9l1.5-5h15L21 9M3 9h18v11H3zM3 9v3a2 2 0 004 0 2 2 0 004 0 2 2 0 004 0 2 2 0 004 0V9"/>';
    else if (t === "Canvas & upholstery") body = '<circle cx="6" cy="6" r="3"/><circle cx="6" cy="18" r="3"/><path d="M8.5 8.5L20 20M8.5 15.5L20 4"/>';
    else if (t === "Shade & solar") body = '<circle cx="12" cy="12" r="4"/><path d="M12 2v3M12 19v3M2 12h3M19 12h3M4.9 4.9l2 2M17 17l2 2M19 4.9l-2 2M7 17l-2 2"/>';
    else body = '<path d="M14 6a4 4 0 00-5.3 5.3l-6 6a1.5 1.5 0 102 2l6-6A4 4 0 0018 10l-2.5 2.5L13 11l2.5-2.5z"/>';
    return open + body + "</svg>";
  }

  function init(root) {
    if (!root || root.dataset.ezLocInited) return;
    root.dataset.ezLocInited = "1";
    var dataUrl = root.getAttribute("data-installers-url");
    var PHONE = root.getAttribute("data-phone") || "1-877-439-7627";
    var PHONE_TEL = TEL(PHONE);

    // element refs
    var $ = function (sel) { return root.querySelector(sel); };
    var elInput = $("[data-ez-loc-input]");
    var elAc = $("[data-ez-loc-ac]");
    var elForm = $("[data-ez-loc-form]");
    var elGeo = $("[data-ez-loc-geo]");
    var elClear = $("[data-ez-loc-clear]");
    var elSearchBtn = $("[data-ez-loc-search-btn]");
    var elPopular = $("[data-ez-loc-popular]");
    var elRadii = $("[data-ez-loc-radii]");
    var elRadiiWrap = $("[data-ez-loc-radii-wrap]");
    var elTypes = $("[data-ez-loc-types]");
    var elStatus = $("[data-ez-loc-status]");
    var elSide = $("[data-ez-loc-side]");
    var elMapEl = $("[data-ez-loc-mapel]");
    var elSkel = $("[data-ez-loc-skel]");
    var elHere = $("[data-ez-loc-here]");
    var elSheetHandle = $("[data-ez-loc-sheet-handle]");
    var elSheetCount = $("[data-ez-loc-sheet-count]");
    var elSheetToggle = $("[data-ez-loc-sheet-toggle]");
    var elShell = $("[data-ez-loc-shell]");

    // state
    var DATA = [];        // installers with idx
    var TYPES = [];
    var ST_NAMES = {};
    var ready = false;
    var origin = null;
    var query = "";
    var radius = 0;
    var typeF = "all";
    var activeIdx = null;
    var hoverIdx = null;
    var moved = false;
    var sheetOpen = false;
    var acTimer = null;

    // leaflet refs
    var map = null, cluster = null, markers = {}, pinIcon = null, pinHi = null, pinAct = null, originMk = null;
    var progFlag = false, fitFlag = true;

    // ---- derived lists -------------------------------------------------------
    function computeList() {
      var arr = DATA.map(function (it) { return Object.assign({}, it); });
      if (typeF !== "all") arr = arr.filter(function (i) { return i.type === typeF; });
      if (origin) {
        arr = arr.filter(function (i) { return i.lat != null; }).map(function (i) { i.mi = milesBetween(origin, i); return i; });
        if (radius) arr = arr.filter(function (i) { return i.mi <= radius; });
        arr.sort(function (a, b) { return a.mi - b.mi; });
      } else {
        arr.sort(function (a, b) { return (a.state + "|" + a.name).localeCompare(b.state + "|" + b.name); });
      }
      return arr;
    }
    function computeNearest() {
      if (!origin) return [];
      var arr = DATA.map(function (it) { return Object.assign({}, it); });
      if (typeF !== "all") arr = arr.filter(function (i) { return i.type === typeF; });
      return arr.filter(function (i) { return i.lat != null; })
        .map(function (i) { i.mi = milesBetween(origin, i); return i; })
        .sort(function (a, b) { return a.mi - b.mi; }).slice(0, 3);
    }

    // ---- rendering -----------------------------------------------------------
    function rowHtml(i) {
      var showMi = origin && i.mi != null && isFinite(i.mi);
      var place = (i.street ? esc(i.street) + " · " : "") + (i.city ? esc(i.city) + ", " : "") + esc(ST_NAMES[i.state] || i.state);
      var links = "";
      if (i.phone) links += '<a class="ez-loc__rlink" href="tel:' + TEL(i.phone) + '" data-stop>' + esc(i.phone) + "</a>";
      if (i.web) links += '<a class="ez-loc__rlink" href="' + esc(webUrl(i.web)) + '" target="_blank" rel="noopener noreferrer nofollow" data-stop>' + esc(i.web) + " ↗</a>";
      links += '<a class="ez-loc__rlink ez-loc__rlink--muted" href="' + esc(dirUrl(i, origin)) + '" target="_blank" rel="noopener noreferrer" data-stop>Directions →</a>';
      return '<div class="ez-loc__res" data-ridx="' + i.idx + '" role="button" tabindex="0">'
        + '<div class="ez-loc__res-top"><span class="ez-loc__res-name">' + esc(i.name) + "</span>"
        + (showMi ? '<span class="ez-loc__res-mi">' + Math.round(i.mi) + " mi</span>" : "") + "</div>"
        + '<div class="ez-loc__res-type">' + typeIconSvg(i.type) + "<span>" + esc(i.type) + "</span></div>"
        + '<div class="ez-loc__res-place">' + place + "</div>"
        + '<div class="ez-loc__res-links">' + links + "</div>"
        + "</div>";
    }
    function renderList() {
      var list = computeList();
      if (elSheetCount) elSheetCount.textContent = list.length + (list.length === 1 ? " result" : " results");
      if (list.length === 0) {
        var near = computeNearest();
        var html;
        if (near.length > 0) {
          html = '<div class="ez-loc__empty">'
            + '<p class="ez-loc__empty-lead">No installer' + (radius ? " within " + radius + " mi" : "") + (typeF !== "all" ? " (" + esc(typeF) + ")" : "")
            + ". Nearest is <b>" + Math.round(near[0].mi) + " mi</b> away — here are the 3 closest:</p></div>"
            + near.map(rowHtml).join("");
        } else {
          html = '<div class="ez-loc__empty"><p class="ez-loc__empty-lead">No installers match. Try a wider radius or different type — or call us: '
            + '<a class="ez-loc__rlink" href="tel:' + PHONE_TEL + '">' + esc(PHONE) + "</a>.</p></div>";
        }
        elSide.innerHTML = html;
      } else {
        elSide.innerHTML = list.map(rowHtml).join("");
      }
      paintRowStates();
      renderMarkers(list);
      updateStatus(list);
    }
    function paintRowStates() {
      var rows = elSide.querySelectorAll("[data-ridx]");
      for (var i = 0; i < rows.length; i++) {
        var idx = +rows[i].getAttribute("data-ridx");
        rows[i].classList.toggle("is-active", idx === activeIdx);
        rows[i].classList.toggle("is-hover", idx === hoverIdx);
      }
    }
    function updateStatus(list) {
      if (!elStatus) return;
      var t = list.length + " installer" + (list.length === 1 ? "" : "s")
        + (origin ? (radius ? " within " + radius + " mi" : "") + " of " + origin.label.split(",")[0] : "")
        + (typeF !== "all" ? " · " + typeF : "");
      elStatus.textContent = t;
      elStatus.classList.remove("is-msg");
    }
    function setMsg(m) { if (elStatus) { elStatus.textContent = m; elStatus.classList.add("is-msg"); } }

    // ---- map -----------------------------------------------------------------
    function tear(sz) {
      return '<svg width="' + sz + '" height="' + (sz * 1.31) + '" viewBox="0 0 26 34" xmlns="http://www.w3.org/2000/svg"><path d="M13 0C5.8 0 0 5.8 0 13c0 9.2 13 21 13 21s13-11.8 13-21C26 5.8 20.2 0 13 0z" fill="' + AC + '"/><circle cx="13" cy="13" r="4.6" fill="#fff"/></svg>';
    }
    function popupHtml(it) {
      var web = it.web ? '<a href="' + esc(webUrl(it.web)) + '" target="_blank" rel="noopener nofollow" style="color:' + AC + ';font-weight:700;text-decoration:none">' + esc(it.web) + " ↗</a>" : "";
      var ph = it.phone ? '<a href="tel:' + TEL(it.phone) + '" style="color:' + AC + ';font-weight:700;text-decoration:none">' + esc(it.phone) + "</a>" : "";
      return '<div style="font-family:\'DM Sans\',sans-serif;min-width:172px"><div style="font-weight:800;font-size:14px;color:#1a1814;line-height:1.25">' + esc(it.name) + "</div>"
        + '<div style="font-size:11px;color:' + AC + ';font-weight:700;margin:2px 0">' + esc(it.type) + "</div>"
        + '<div style="font-size:12px;color:#776b5b;margin:0 0 6px">' + (it.street ? esc(it.street) + "<br>" : "") + (it.city ? esc(it.city) + ", " : "") + esc(it.state) + "</div>"
        + '<div style="font-size:12px;display:flex;gap:12px;flex-wrap:wrap">' + ph + web + "</div>"
        + '<a href="' + esc(dirUrl(it, origin)) + '" target="_blank" rel="noopener" style="display:inline-block;margin-top:8px;font-size:12px;font-weight:700;color:#1a1814;text-decoration:none">Get directions →</a></div>';
    }
    function buildMap() {
      var L = window.L;
      map = L.map(elMapEl, { zoomControl: true, scrollWheelZoom: true }).setView([39.5, -98.35], 4);
      // CARTO basemaps require a key since 2026-09 (keyless tiles return an "API KEY REQUIRED" watermark).
      // Public client key, commercial free tier (1M req/mo).
      L.tileLayer("https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png?key=cb1_423z_1_37dc775f2272db7c405793f4", { subdomains: "abcd", maxZoom: 19, attribution: "&copy; OpenStreetMap &copy; CARTO" }).addTo(map);
      pinIcon = L.divIcon({ className: "ez-pin-wrap", html: tear(26), iconSize: [26, 34], iconAnchor: [13, 34], popupAnchor: [0, -30] });
      pinHi = L.divIcon({ className: "ez-pin-wrap", html: tear(34), iconSize: [34, 45], iconAnchor: [17, 45], popupAnchor: [0, -40] });
      pinAct = L.divIcon({ className: "ez-pin-wrap", html: '<div class="ez-pin-act"><span class="ring"></span>' + tear(36) + "</div>", iconSize: [36, 47], iconAnchor: [18, 47], popupAnchor: [0, -42] });
      cluster = L.markerClusterGroup({
        showCoverageOnHover: false, maxClusterRadius: 48,
        iconCreateFunction: function (cc) {
          var n = cc.getChildCount();
          var sz = n < 10 ? 34 : n < 50 ? 42 : 50;
          return L.divIcon({ html: '<div class="ez-cluster" style="width:' + sz + "px;height:" + sz + "px;line-height:" + sz + 'px">' + n + "</div>", className: "", iconSize: [sz, sz] });
        }
      });
      DATA.forEach(function (it) {
        if (it.lat == null) return;
        var m = L.marker([it.lat, it.lng], { icon: pinIcon });
        m.bindPopup(function () { return popupHtml(it); });
        m.on("click", function () { setActive(it.idx); });
        m.on("mouseover", function () { setHover(it.idx); });
        m.on("mouseout", function () { setHover(null); });
        markers[it.idx] = m;
      });
      map.addLayer(cluster);
      map.on("moveend", function () { if (progFlag) { progFlag = false; return; } moved = true; syncHere(); });
      ready = true;
      if (elSkel) elSkel.style.display = "none";
      if (elMapEl) elMapEl.style.opacity = "1";
    }
    function renderMarkers(list) {
      if (!cluster || !ready || !map) return;
      var L = window.L;
      cluster.clearLayers();
      list.forEach(function (i) { var m = markers[i.idx]; if (m) cluster.addLayer(m); });
      if (origin && fitFlag) {
        var near = list.slice(0, 8).filter(function (i) { return i.lat != null; }).map(function (i) { return [i.lat, i.lng]; });
        near.push([origin.lat, origin.lng]);
        progFlag = true;
        if (near.length > 1) map.fitBounds(L.latLngBounds(near), { padding: [50, 50], maxZoom: 11 });
        else map.flyTo([origin.lat, origin.lng], 9, { duration: 0.7 });
      }
      fitFlag = true; moved = false; syncHere();
    }
    function renderOriginMarker() {
      if (!ready || !map) return;
      var L = window.L;
      if (originMk) { map.removeLayer(originMk); originMk = null; }
      if (origin) originMk = L.marker([origin.lat, origin.lng], { icon: L.divIcon({ className: "", html: '<div class="ez-origin"></div>', iconSize: [20, 20], iconAnchor: [10, 10] }), zIndexOffset: 3000 }).addTo(map);
    }
    function paintPins() {
      Object.keys(markers).forEach(function (k) {
        var m = markers[k]; if (!m || !pinIcon) return;
        var idx = +k;
        m.setIcon(idx === activeIdx ? pinAct : idx === hoverIdx ? pinHi : pinIcon);
        m.setZIndexOffset(idx === activeIdx ? 2000 : 0);
      });
    }
    function syncHere() {
      if (!elHere) return;
      elHere.hidden = !(ready && moved && origin);
    }

    // ---- interactions --------------------------------------------------------
    function setActive(idx) { activeIdx = idx; paintRowStates(); paintPins(); scrollToActive(); syncUrl(); }
    function setHover(idx) { hoverIdx = idx; paintRowStates(); paintPins(); }
    function scrollToActive() {
      if (activeIdx == null) return;
      var el = elSide.querySelector('[data-ridx="' + activeIdx + '"]');
      if (el) el.scrollIntoView({ block: "nearest", behavior: "smooth" });
    }
    function focusInstaller(idx) {
      var m = markers[idx];
      setActive(idx);
      if (m && cluster) { progFlag = true; cluster.zoomToShowLayer(m, function () { m.openPopup(); }); }
    }
    function pick(o) { fitFlag = true; radius = DEFAULT_RADIUS; origin = o; setSugg([]); query = o.label.split(",").slice(0, 2).join(","); if (elInput) elInput.value = query; afterOriginChange(); }
    function afterOriginChange() {
      syncRadiiVisibility(); syncClear(); renderOriginMarker(); renderList(); syncUrl();
    }
    function syncRadiiVisibility() {
      if (!elRadiiWrap) return;
      elRadiiWrap.hidden = !origin;
      if (origin && elRadii) {
        var chips = elRadii.querySelectorAll("[data-radius]");
        for (var i = 0; i < chips.length; i++) chips[i].classList.toggle("is-active", +chips[i].getAttribute("data-radius") === radius);
      }
      if (elPopular) elPopular.hidden = !!origin;
    }
    function syncClear() { if (elClear) elClear.hidden = !origin; }

    function setSugg(items) {
      if (!elAc) return;
      if (!items || !items.length) { elAc.innerHTML = ""; elAc.hidden = true; return; }
      elAc.innerHTML = items.map(function (s, i) {
        return '<div class="ez-loc__ac-item" data-ac="' + i + '">' + esc(s.label) + "</div>";
      }).join("");
      elAc.hidden = false;
      elAc._items = items;
    }
    function onQueryChange(v) {
      query = v;
      if (acTimer) clearTimeout(acTimer);
      if (v.trim().length < 3) { setSugg([]); return; }
      acTimer = setTimeout(function () {
        geocode(v).then(function (r) { setSugg(r); }).catch(function () {});
      }, 350);
    }
    function onSearch(e) {
      if (e) e.preventDefault();
      if (!query.trim()) return;
      setMsg(""); setSugg([]);
      if (elSearchBtn) { elSearchBtn.textContent = "Searching…"; elSearchBtn.disabled = true; }
      geocode(query.trim()).then(function (r) {
        if (r[0]) pick(r[0]); else setMsg("No location matched — try a city or ZIP.");
      }).catch(function () { setMsg("Search is unavailable right now."); })
        .then(function () { if (elSearchBtn) { elSearchBtn.textContent = "Search"; elSearchBtn.disabled = false; } });
    }
    function useMyLoc() {
      if (!navigator.geolocation) { setMsg("Geolocation isn't supported here."); return; }
      setMsg("");
      navigator.geolocation.getCurrentPosition(function (p) {
        fitFlag = true; radius = DEFAULT_RADIUS;
        origin = { lat: p.coords.latitude, lng: p.coords.longitude, label: "Your location" };
        query = ""; if (elInput) elInput.value = "";
        afterOriginChange();
      }, function () { setMsg("Couldn't get your location."); });
    }
    function searchHere() {
      if (!map) return;
      var c = map.getCenter();
      fitFlag = false; radius = DEFAULT_RADIUS;
      origin = { lat: c.lat, lng: c.lng, label: "this map area" };
      afterOriginChange();
    }
    function clearAll() {
      origin = null; query = ""; if (elInput) elInput.value = ""; setSugg([]);
      radius = 0; activeIdx = null; moved = false;
      syncRadiiVisibility(); syncClear(); renderOriginMarker(); renderList(); syncUrl();
      if (map) { progFlag = true; map.flyTo([39.5, -98.35], 4, { duration: 0.7 }); }
    }
    function syncUrl() {
      if (typeof window === "undefined" || !window.history || !window.history.replaceState) return;
      try {
        var u = new URL(window.location.href);
        if (origin) u.searchParams.set("near", origin.lat.toFixed(4) + "," + origin.lng.toFixed(4)); else u.searchParams.delete("near");
        if (activeIdx != null) u.searchParams.set("installer", String(activeIdx)); else u.searchParams.delete("installer");
        window.history.replaceState({}, "", u);
      } catch (e) {}
    }

    // ---- static chrome wiring ------------------------------------------------
    function buildPopularChips() {
      if (!elPopular) return;
      var html = '<span class="ez-loc__chips-lbl">Popular:</span>';
      html += POPULAR.map(function (c) { return '<button type="button" class="ez-loc__chip" data-popular="' + esc(c) + '">' + esc(c.split(",")[0]) + "</button>"; }).join("");
      elPopular.innerHTML = html;
    }
    function buildRadiiChips() {
      if (!elRadii) return;
      var html = '<span class="ez-loc__filters-lbl">Within</span>';
      html += RADII.map(function (r) { return '<button type="button" class="ez-loc__chip" data-radius="' + r.v + '">' + r.l + "</button>"; }).join("");
      elRadii.innerHTML = html;
    }
    function buildTypeChips() {
      if (!elTypes) return;
      var html = '<span class="ez-loc__filters-lbl">Type</span>';
      html += '<button type="button" class="ez-loc__chip is-active" data-type="all">All</button>';
      html += TYPES.map(function (t) { return '<button type="button" class="ez-loc__chip" data-type="' + esc(t) + '">' + esc(t) + "</button>"; }).join("");
      elTypes.innerHTML = html;
    }
    function setType(t) {
      typeF = t;
      var chips = elTypes.querySelectorAll("[data-type]");
      for (var i = 0; i < chips.length; i++) chips[i].classList.toggle("is-active", chips[i].getAttribute("data-type") === t);
      renderList();
    }
    function setRadius(v) {
      fitFlag = true; radius = v;
      var chips = elRadii.querySelectorAll("[data-radius]");
      for (var i = 0; i < chips.length; i++) chips[i].classList.toggle("is-active", +chips[i].getAttribute("data-radius") === v);
      renderList();
    }

    function wireEvents() {
      if (elForm) elForm.addEventListener("submit", onSearch);
      if (elInput) elInput.addEventListener("input", function () { onQueryChange(this.value); });
      if (elGeo) elGeo.addEventListener("click", useMyLoc);
      if (elClear) elClear.addEventListener("click", clearAll);
      if (elHere) elHere.addEventListener("click", searchHere);
      if (elSheetToggle) elSheetToggle.addEventListener("click", toggleSheet);
      // suggestion clicks
      if (elAc) elAc.addEventListener("click", function (e) {
        var t = e.target.closest("[data-ac]"); if (!t) return;
        var items = elAc._items || []; var s = items[+t.getAttribute("data-ac")];
        if (s) pick(s);
      });
      // close suggestions on outside click
      document.addEventListener("click", function (e) {
        if (elAc && !elAc.hidden && !elAc.contains(e.target) && e.target !== elInput) setSugg([]);
      });
      // popular / radius / type chips (delegation)
      if (elPopular) elPopular.addEventListener("click", function (e) {
        var t = e.target.closest("[data-popular]"); if (!t) return;
        var c = t.getAttribute("data-popular"); query = c; if (elInput) elInput.value = c;
        geocode(c).then(function (r) { if (r[0]) pick(r[0]); }).catch(function () {});
      });
      if (elRadii) elRadii.addEventListener("click", function (e) {
        var t = e.target.closest("[data-radius]"); if (!t) return; setRadius(+t.getAttribute("data-radius"));
      });
      if (elTypes) elTypes.addEventListener("click", function (e) {
        var t = e.target.closest("[data-type]"); if (!t) return; setType(t.getAttribute("data-type"));
      });
      // result list (delegation): click focuses, links stop propagation
      if (elSide) {
        elSide.addEventListener("click", function (e) {
          if (e.target.closest("[data-stop]")) return;
          var row = e.target.closest("[data-ridx]"); if (!row) return;
          focusInstaller(+row.getAttribute("data-ridx"));
        });
        elSide.addEventListener("keydown", function (e) {
          var row = e.target.closest("[data-ridx]"); if (!row) return;
          if (e.key === "Enter" || e.key === " ") { e.preventDefault(); focusInstaller(+row.getAttribute("data-ridx")); }
        });
        elSide.addEventListener("mouseover", function (e) {
          var row = e.target.closest("[data-ridx]"); if (row) setHover(+row.getAttribute("data-ridx"));
        });
        elSide.addEventListener("mouseout", function (e) {
          var row = e.target.closest("[data-ridx]"); if (row) setHover(null);
        });
      }
    }
    function toggleSheet() {
      sheetOpen = !sheetOpen;
      if (elShell) elShell.classList.toggle("is-sheet-open", sheetOpen);
      if (elSheetToggle) elSheetToggle.textContent = sheetOpen ? "Hide ▾" : "Show ▴";
    }

    // ---- url params on load --------------------------------------------------
    function applyUrlParams() {
      if (typeof window === "undefined") return null;
      var sp = new URLSearchParams(window.location.search);
      var near = sp.get("near"), inst = sp.get("installer");
      if (near) {
        radius = DEFAULT_RADIUS;
        var m = near.match(/^(-?\d+\.?\d*),(-?\d+\.?\d*)$/);
        if (m) { origin = { lat: +m[1], lng: +m[2], label: "Shared location" }; }
        else { query = near; if (elInput) elInput.value = near; geocode(near).then(function (r) { if (r[0]) { origin = r[0]; afterOriginChange(); } }); }
      }
      return (inst != null && DATA[+inst]) ? +inst : null;
    }

    // ---- boot ----------------------------------------------------------------
    buildPopularChips(); buildRadiiChips(); buildTypeChips(); wireEvents();

    fetch(dataUrl).then(function (r) { return r.json(); }).then(function (payload) {
      TYPES = payload.types || [];
      ST_NAMES = payload.stNames || {};
      DATA = (payload.installers || []).map(function (it, idx) { it.idx = idx; return it; });
      buildTypeChips(); // now with real TYPES
      // re-wire the (rebuilt) type chip container listener is already delegated on elTypes — fine
      var pendingInst = applyUrlParams();
      syncRadiiVisibility(); syncClear();
      renderList(); // renders the JS list into the left column (replaces skeleton/noscript-equivalent)

      // load leaflet + markercluster, then build map
      loadCss(LEAFLET_CSS); loadCss(MC_CSS1); loadCss(MC_CSS2);
      loadScript(LEAFLET_JS).then(function () { return loadScript(MC_JS); }).then(function () {
        buildMap();
        renderOriginMarker();
        renderList(); // re-render now that markers exist so map syncs
        if (pendingInst != null) focusInstaller(pendingInst);
      }).catch(function () {
        setMsg("Map couldn't load — the installer list is still below.");
        if (elSkel) elSkel.style.display = "none";
      });
    }).catch(function () {
      setMsg("Couldn't load the installer list right now — call us: " + PHONE + ".");
      if (elSkel) elSkel.style.display = "none";
    });
  }

  function boot() {
    var roots = document.querySelectorAll("[data-ez-loc]");
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
